// extracted by mini-css-extract-plugin
module.exports = {"root":"_b17b4d","icon":"_ab14a6","typography":"_3ef127","spanWhiteSpace":"_5106aa","spanReviewsYet":"_e19723"};